import React, { Component } from 'react';
import { T } from '../../../../../../common/locale/translate';
import { parse_weather_object } from '../../../../services/services';
import Table from '../../../../common/components/responsive-table';
import WeatherGraph from './graph';

export default class ReviewsTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      weather_data: [],
      pristine: true,
      headers: [
        { name: 'legend', title: '' },
        { name: 'graph', title: 'I' },
        { name: 'graph', title: 'II' },
        { name: 'graph', title: 'III' },
        { name: 'graph', title: 'IV' },
        { name: 'graph', title: 'V' },
        { name: 'graph', title: 'VI' },
        { name: 'graph', title: 'VII' },
        { name: 'graph', title: 'VIII' },
        { name: 'graph', title: 'IX' },
        { name: 'graph', title: 'X' },
        { name: 'graph', title: 'XI' },
        { name: 'graph', title: 'XII' }
      ]
    };
  }

  componentWillReceiveProps(nextProps) {
    if (typeof nextProps.data != 'undefined' && this.state.pristine) {
      const weather_data = parse_weather_object(nextProps.data);
      this.setState({ weather_data, pristine: false });
    }
  }

  render = () => (
    <div className="weather-graphs">
      <h3 className="weather-graphs-title">{T('weather_graphs_title')}</h3>
      <section className="graphs">
        <Table headers={this.state.headers}>
          {this.state.weather_data.map((data, i) => {
            return <WeatherGraph data={data} key={i} className={data.type} />;
          })}
        </Table>
      </section>
    </div>
  );
}



// WEBPACK FOOTER //
// ./app/javascript/pages/offer/components/weather/index.js